import React from 'react'

import { useUnit } from 'effector-react'
import PropTypes from 'prop-types'

import { useState } from 'hooks'

import { $pendingOrders } from 'app/effector/pending-orders'

import Link from 'components/_old/Link/Link.jsx'
import { Typo } from 'components/_old/Typo/Typo'

import { Paper } from 'components/atoms/Paper'
import { SelectableCard } from 'components/atoms/SelectableCard'
import { Typography } from 'components/atoms/Typography'

import { UseRestrictionTypes } from 'app/pages/Dashboard/Goals/DIY/hooks'
import { Restrictions } from 'app/pages/Dashboard/Goals/DIY/Restrictions'

import { scope as pendingOrderScope } from 'constants/pendingOrder.js'

import './AddSecurities.css'

const AddSecurities = ({ onClick, shouldRestrictIfPortfolioHasPendingOrders = false, portfolioId }) => {
  const [restrictionModalOpen, setRestrictionModalOpen] = useState(false)

  const orders = useUnit($pendingOrders)

  const handleClick = () => {
    const hasPendingPortfolioScopedOrders =
      portfolioId && !!orders.getByPortfolioId(portfolioId).getByScope(pendingOrderScope.PORTFOLIO)?.length

    if (shouldRestrictIfPortfolioHasPendingOrders && hasPendingPortfolioScopedOrders) {
      setRestrictionModalOpen(true)
    } else {
      onClick()
    }
  }

  return (
    <React.Fragment>
      <Link className="AddSecurities" onClick={handleClick}>
        <SelectableCard data-test-id="addSecuritiesButton">
          <Paper top={12} right={20} bottom={12} left={20}>
            <Typography color="inherit" align="center">
              <Typo>+ Add securities</Typo>
            </Typography>
          </Paper>
        </SelectableCard>
      </Link>
      <Restrictions
        portfolioId={portfolioId}
        open={restrictionModalOpen}
        onClose={() => setRestrictionModalOpen(false)}
        type={UseRestrictionTypes.EDIT}
      />
    </React.Fragment>
  )
}

AddSecurities.propTypes = {
  onClick: PropTypes.func,
  shouldRestrictIfPortfolioHasPendingOrders: PropTypes.bool,
  portfolioId: PropTypes.number,
}

export { AddSecurities }
